module.exports = __webpack_public_path__ + "static/media/illo-calendar.5c7b45cc.png";